import { useCallback, useMemo, useState } from 'react';

import { JonumSelfExclusionGateContext } from '#src/contexts/jonumSelfExclusionGate/index.ts';
import { Level } from '#src/contexts/snackNotification/index.ts';
import { notificationsQueue } from '#src/hooks/useNotificationsQueue.ts';

import { JonumComposeBlockedDialog } from '../JonumComposeBlockedDialog/index.tsx';

type Props = {
  children: React.ReactNode;
};

export const JonumSelfExclusionGateProvider = ({ children }: Props) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const close = useCallback(() => setErrorMessage(null), []);

  const showErrorInstead = useCallback(() => {
    if (errorMessage) {
      notificationsQueue.addNotification(
        'errors',
        { errors: errorMessage },
        { level: Level.ERROR }
      );
    }
    close();
  }, [errorMessage, close]);

  const value = useMemo(
    () => ({ openJonumSelfExclusion: setErrorMessage }),
    []
  );

  return (
    <JonumSelfExclusionGateContext.Provider value={value}>
      {children}
      <JonumComposeBlockedDialog
        open={errorMessage !== null}
        selfExclusionOnly
        onClose={close}
        onNothingToShow={showErrorInstead}
      />
    </JonumSelfExclusionGateContext.Provider>
  );
};
